import { render, staticRenderFns } from "./salesTodayTasks.vue?vue&type=template&id=d8dc27e0&scoped=true"
import script from "./salesTodayTasks.vue?vue&type=script&lang=js"
export * from "./salesTodayTasks.vue?vue&type=script&lang=js"
import style0 from "./salesTodayTasks.vue?vue&type=style&index=0&id=d8dc27e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8dc27e0",
  null
  
)

export default component.exports